import React, { useEffect, Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'Core/defaultValues';
import { LogManagerConsole } from 'Core/logManager';

import {
	catalogProcessItem,
	catalogProcessItems,
	refreshToken,
	catalogInitialRefresh,
	catalogSyncPushNotifications,
	logout,
	catalogInitialGetUnit,
	clearRedux
} from 'Redux/actions';

import { processNotification, updateActivityUser } from './redux/slice'
import { getDevicesInitialData } from './redux/sliceRealtime';
import SocketManager from '../realtime/SocketManager';


let newIntervalHeartBeat = null
var autoRefresh;
var autoRefreshPN;

const Catalog = () => {

	const dispatch = useDispatch();
	const { user, refreshTokenResult, systemPreference } = useSelector(state => state.securityRedux);
	const navigate = useNavigate()

	//Efect to create socket connection
	useEffect(() => {
		//get variables to override from global preferences
		let refreshTime = systemPreference && systemPreference[process.env.STACK]?.refreshTime || 0
		refreshTime = Number(refreshTime)

		let offSocketConnect = systemPreference && systemPreference[process.env.STACK]?.offSocketConnect || 0
		offSocketConnect = Number(offSocketConnect)

		let refreshTimePN = systemPreference && systemPreference[process.env.STACK]?.refreshTimePN || 0
		refreshTimePN = Number(refreshTimePN)

		LogManagerConsole("DC_Diferencial", "refreshTime", refreshTime, "refreshTimePN", refreshTimePN, "offSocketConnect", offSocketConnect)

		//load initial values
		dispatch(getDevicesInitialData())
		dispatch(updateActivityUser({}))

		//if is enable Diferential Units info
		if (refreshTime > 0) {

			const refreshTimeCallback = () => {
				//valid only for this company
				if (user.companyId == 26091) {
					refreshTime = 15
				}

				autoRefresh && clearTimeout(autoRefresh)
				autoRefresh = setTimeout(() => {
					LogManagerConsole("DC_Diferencial", "Evaluate in")
					let lastReadingSyncString = sessionStorage.getItem("lastSyncLastReading") || moment().add(-1, "minutes").toString()
					let lastReadingSync = moment(lastReadingSyncString).add(refreshTime - 1, 'seconds');

					let lastDatacatalogSync = moment().add(refreshTime - 1, 'seconds');
					LogManagerConsole("DC_Diferencial", "Evaluate", lastReadingSync)
					//update info when socket is down or not return information.

					if (lastReadingSync < moment()) {

						// if (offSocketConnect == 0 && lastDatacatalogSync >= moment())
						// 	return false

						//eval the time with dataCatalog
						LogManagerConsole("DC_Diferencial", "Automatic Refresh LastReading")
						sessionStorage.setItem("lastSyncLastReading", moment())
						dispatch(catalogInitialRefresh(refreshTime));
					}

					refreshTimeCallback()
				}, refreshTime * 1000)
			}

			refreshTimeCallback()
		}

		//if is enable PushNotification Diferential
		if (refreshTimePN > 0) {

			const refresTimePNCallback = () => {
				autoRefreshPN && clearTimeout(autoRefreshPN)
				autoRefreshPN = setTimeout(() => {
					let lastSyncNotificationString = sessionStorage.getItem("lastSyncNotification") || moment().add(-1, "minutes").toString()
					let lastSyncNotificationSync = moment(lastSyncNotificationString).add(refreshTimePN, 'seconds');
					if (lastSyncNotificationSync < moment()) {
						sessionStorage.setItem("lastSyncNotification", moment())
						let sessionId = sessionStorage.getItem("sessionId")
						dispatch(catalogSyncPushNotifications(sessionId, user.companyId, { start: moment().add(-2, "hours"), end: moment().toDate() }));
					}

					refresTimePNCallback()
				}, refreshTimePN * 1000)
			}

			refresTimePNCallback()
		}


		//if socket is enabled
		if (offSocketConnect == 0) {
			LogManagerConsole("DC", 'init SocketManager');
			SocketManager.init(user, systemPreference);
		}

		return () => {
			SocketManager.close();
			if (autoRefresh) clearTimeout(autoRefresh)
			if (autoRefreshPN) clearTimeout(autoRefreshPN)
			if (newIntervalHeartBeat) clearInterval(newIntervalHeartBeat)
		};

	}, []);

	if (!newIntervalHeartBeat) {
		newIntervalHeartBeat = setInterval(() => {
			dispatch(updateActivityUser({}))
		}, 120000);
	}

	useEffect(() => {

		LogManagerConsole("DC", refreshTokenResult)
		if (refreshTokenResult) {
			dispatch(clearRedux("DC", "AUTHCOMPONENT", { refreshTokenResult: false }))
			LogManagerConsole("DC", "refresh SocketManager reconnect")
			SocketManager.reconnectSocket()
		}
	}, [refreshTokenResult])

	return <></>;
};



export default Catalog;
